// GO2 eFB — OZELLIK KATALOGU (super admin settings)
// Tam tasarim: GO2EFB/CLAUDE.md -> "SUPER ADMIN SETTINGS — onayli tasarim"
//
// TEK KAYNAK: hangi anahtar var, varsayilani ne, kapatilinca nereler etkilenir.
// DB'de yalnizca SAPMALAR tutulur (customers.features, ornek: {"ui.raaq": false}).
//
// KATALOGDA OLAN = KAPATILABILIR OLAN. (Sirketin deger ayarlari — DEGER_AYARLARI — ayri listede, asagida.)
// Cekirdek moduller (Fuel, NavLog, T/O, LDG, Accept & Sign, arsiv) burada YOKTUR
// ve kodda isEnabled() cagirmazlar -> yapisal olarak kapatilamazlar. Boylece
// "cekirdek kapanmasin" kurali icin DB trigger'i gerekmez.
//
// KURAL 8 — BELIRSIZLIK = ACIK: katalogda olmayan anahtar, okunamayan
// konfigurasyon, bozuk snapshot -> modul GORUNUR ve kapi CALISIR. Asla ters yon;
// kapaliya dusmek kapi kaldirmak demektir.

export const FEATURE_CATALOG = [
  // ---------- UI (iPad) ----------
  {
    key: 'ui.flightcrew.czib', section: 'ui', module: 'FLT CREW', label: 'CZIB',
    kind: 'module', defaultOn: true,
    affects: [
      'FLT CREW ekranindaki CZIB gosterimi kalkar',
      'czib-check sorgusu HIC atilmaz (arka plan da calismaz)',
      'czib_snapshots kaydi olusmaz',
      'Rapordaki CZIB bolumu gorunmez',
      'Help/FAQ CZIB bolumu gorunmez',
    ],
    note: 'Kuresel bolge senkronu (czib-sync) etkilenmez — musteriye ozel degildir.',
  },
  {
    key: 'ui.raaq', section: 'ui', module: 'RAAQ', label: 'RAAQ modulu',
    kind: 'module', defaultOn: true,
    affects: [
      'RAAQ ekrani menude gorunmez',
      'Accept & Sign listesinden CIKAR (sayac 5/5 degil 4/4 olur)',
      'rass_data / RAAQ kaydi olusmaz',
      'Rapordaki RAAQ bolumu gorunmez',
      'Help/FAQ RAAQ bolumu gorunmez',
    ],
    note: 'Sahte GREEN yazilmaz — modul listeden cikarilir (Ilke 1).',
  },
  {
    key: 'ui.takeoff.oeo', section: 'ui', module: 'T/O DATA', label: 'OEO DP butonu',
    kind: 'button', defaultOn: true,
    affects: ['T/O ekranindaki OEO butonu gorunmez', 'perf_oeo ayristirmasi yapilmaz'],
    note: 'Kapisi YOK — hicbir zorunluluk kalkmaz.',
  },
  {
    key: 'ui.takeoff.lmc', section: 'ui', module: 'T/O DATA', label: 'LMC',
    kind: 'button', defaultOn: true,
    affects: ['T/O ekranindaki LMC alani gorunmez', 'Rapordaki LMC satiri gorunmez'],
    note: 'Kapisi YOK — PreArchiveCheck.swift:245 "LMC ve OTH: opsiyonel, kontrol edilmez".',
  },
  {
    key: 'ui.navlog.foreflight', section: 'ui', module: 'NAVLOG', label: 'OPEN FOREFLIGHT',
    kind: 'button', defaultOn: true,
    affects: ['NavLog\'daki ForeFlight butonu gorunmez'],
    note: 'Kapisi YOK — veri uretmez, yalnizca disari rota gonderir.',
  },
  // ⚰️ 'ui.navlog.fmsimport' (ADD ROUTING FROM FMS) KALDIRILDI — 12 Eki 2026, Serkan:
  // *"fotodan wpt ekleme kalksin, super adminde de butonu kalksin"*. iPad Build 76'da
  // fotograftan okuma koddan cikti; elle giris (ADD WAYPOINT) anahtarsiz, hep acik.
  // DB'de kalan eski sapma silinmez (toggleFeature bilinmeyen anahtari korur) —
  // Build 75 tabletler o degeri okumaya devam eder.
  {
    key: 'ui.lnddata.qnh', section: 'ui', module: 'LDG DATA', label: 'QNH',
    kind: 'cell', defaultOn: true,
    affects: [
      'LDG DATA\'daki QNH alani gorunmez',
      'PreArchiveCheck "QNH missing" maddesi URETILMEZ',
      'Rapordaki QNH satiri gorunmez (BOS degil — HIC yok)',
    ],
    note: 'Kayit yeri meselesi: bazi operatorlerde deger FMS/ATIS akisinda kalir, OM\'leri EFB kaydini istemez.',
  },
  {
    key: 'ui.lnddata.rwycond', section: 'ui', module: 'LDG DATA', label: 'RUNWAY CONDITION',
    kind: 'cell', defaultOn: true,
    affects: [
      'LDG DATA\'daki RWY COND alani gorunmez',
      'PreArchiveCheck "RUNWAY CONDITION not set" maddesi URETILMEZ',
      'Rapordaki RWY COND satiri gorunmez',
    ],
    note: 'Serkan (10 Agu): bazi uygulamalarda FMS\'de seciliyor ve OM\'lerine gore yeterli; REC OFP kaydini istiyor.',
  },
  {
    key: 'ui.lnddata.vref', section: 'ui', module: 'LDG DATA', label: 'VREF',
    kind: 'cell', defaultOn: true,
    affects: [
      'LDG DATA\'daki VREF alani gorunmez',
      'PreArchiveCheck "VREF missing" maddesi URETILMEZ',
      'Rapordaki VREF satiri gorunmez',
    ],
    note: 'Serkan (10 Agu): flap secip surati FMS\'ten okuyup ayri perf hesabi yapan operatorler kaydi istemiyor.',
  },
  {
    // 10 Agu 2026: BASTA IKI ANAHTARDI (W&B + PERF), TEKE INDIRILDI.
    // Sebep: iOS'ta ayri iki yukleme yeri YOK — DocUploadView'da tek bir
    // zorunlu bolum var ("Analysis / TOLD / W&B ayri ayri ya da tek birlesik
    // dosya olabilir"). Iki anahtar birakmak, panelde hicbir seyi kapatmayan
    // bir dugme demekti; katalog uygulamayla ortusmek zorunda.
    key: 'ui.docupload.perf', section: 'ui', module: 'DOC UPLOAD',
    label: 'PERF & LOADING PLAN (zorunlu belge)',
    kind: 'cell', defaultOn: true,
    affects: [
      'DOC UPLOAD\'daki zorunlu PERF & LOADING PLAN bolumu gorunmez (W&B / TOLD / Analysis dahil)',
      'PERF ayristirmasi calismaz: rota-tarih dogrulamasi, TRIM ve OEO usulleri cikarilmaz',
      'Doc Upload modulu bu belge olmadan da GREEN olur',
      'EndFlt\'teki "W&B yok, yine de arsivle?" ONAY SORUSU sorulmaz',
      'ui.perf.runways OTOMATIK KAPANIR (belge yuklenemedigi icin okunacak tablo kalmaz); PERF geri acilinca kendiliginden geri GELMEZ',
    ],
    note: 'Sert kapi degil, onayli uyari kapisi (PreArchiveCheck.swift:203). ANY UPLOAD (serbest dokuman) HER ZAMAN acik kalir.',
  },
  {
    // 28-29 Agu 2026 — Serkan: "pist isimlerini WXR report'tan cekiyoruz ya,
    // orada bir kirilganlik var; PPS veya handling sirketi formatta degisiklik
    // yapinca orasi kiriliyor." Kaynak artik her ucusta zaten yuklenen PERF
    // belgesi (W&B + TOLD + Analysis booklet'i).
    //
    // ⚠️ KATALOGDAKI TEK KAPALI VARSAYILAN — VE BILINCLI TERS YON.
    // Oteki anahtarlarda "acik" fail-safe'tir (eksik konfigurasyon bir emniyet
    // ozelligini sessizce kaldirmasin). Burada tersi: bu anahtar ACIKKEN
    // calisan WXR yolu devre disi kalir. Varsayilan acik olsaydi surum ciktigi
    // anda butun sirketlerde eski yol kalkardi.
    //
    // 🔴 defaultOn iOS'taki varsayilanla (FeatureFlags.defaults) BIREBIR ayni
    // olmak zorunda: panel yalnizca SAPMALARI yaziyor, dolayisiyla burada
    // yanlislikla `true` yazsaydik dugmeyi acmak anahtari SILER, iOS varsayilana
    // (kapali) duser ve dugme "acik" gorunup hicbir sey yapmazdi.
    key: 'ui.perf.runways', section: 'ui', module: 'T/O + LDG DATA',
    label: 'Pist listesi ve ASDA/LDA perf belgesinden',
    kind: 'cell', defaultOn: false,
    // 🔑 BAGIMLILIK VERIDE DURUR, PANELIN HATIRLAMASINA BIRAKILMAZ
    // (29 Agu 2026, Serkan): "1. kapaninca 2. otomatik kapansin; ancak 1.
    // acilinca 2. ister on ister off olsun."
    // Tek yon: ebeveyn KAPANINCA bu anahtar da kapanir. Ebeveyn tekrar
    // acilinca bu anahtar KENDILIGINDEN GERI GELMEZ — yonetici karar verir.
    // Ters yonu de otomatiklestirseydik, PERF'i geri acan yonetici pist
    // ozelliginin de dondugunu SANIRDI; halbuki bir sey degismemis olurdu.
    dependsOn: 'ui.docupload.perf',
    affects: [
      'ACIK: T/O DATA ve LDG DATA pist listesi PERF belgesinden okunur — kavsak kalkislari dahil (or. 03L-G2, 10LARR)',
      'ACIK: pist secilince ASDA (kalkis) / LDA (inis) hanesi kendiliginden dolar; elle degistirilirse belgedeki deger yaninda yazar',
      'KAPALI: pist listesi eski yoldan, OFP/WXR ham metninden taranir',
      'Belge yoksa ya da tablo okunamazsa liste BOS kalir ve elle giris istenir — uydurma pist/mesafe gosterilmez',
    ],
    note: 'ui.docupload.perf KAPALIYSA bu anahtar ETKISIZDIR (belge yuklenemez, tablo hic yazilmaz); bagimlilik iOS\'ta kodda tutulur (FeatureFlags.perfRunwaysActive), arayuzun hatirlamasina birakilmadi. AYRICA: ASDA/LDA artik emniyet kapisinda — hane bos ise modul GREEN olmaz (anahtardan bagimsiz).',
  },

  // ---------- WEB ADMIN ----------
  {
    key: 'admin.ftl', section: 'admin', module: 'ADMIN', label: 'FTL modulu',
    kind: 'module', defaultOn: true,
    affects: [
      'Admin panelde FTL sekmesi gorunmez',
      'crew_duties satiri URETILMEZ (archive-flight FTL adimi calismaz)',
      'Rapordaki FTL bolumu gorunmez — calismayan modul hesap yapamaz',
      'Help/FAQ FTL bolumu gorunmez',
    ],
    note: 'Kural 7: sonradan acilirsa gecmis gorevler geriye donuk URETILMEZ; acildigi tarihten ilerler.',
  },
  {
    key: 'admin.raaq', section: 'admin', module: 'ADMIN', label: 'RAAQ / risk assessment listesi',
    kind: 'module', defaultOn: true,
    affects: [
      'Admin panelde RAAQ listesi gorunmez',
      'airport_risks yonetimi kullanilamaz',
    ],
  },
];

const BY_KEY = Object.fromEntries(FEATURE_CATALOG.map(f => [f.key, f]));

// Katalog kaydi (varsayilan deger ve bagimlilik icin).
export function entryOf(key) { return BY_KEY[key] || null; }

// Bu anahtara BAGLI olanlar. Ebeveyn kapatilinca birlikte kapanirlar.
export function dependentsOf(key) {
  return FEATURE_CATALOG.filter(f => f.dependsOn === key).map(f => f.key);
}

// Varsayilana donen anahtar kayittan SILINIR — kayitta yalnizca sapmalar durur.
function yaz(obj, key, val) {
  const e = BY_KEY[key];
  if (!e) return;
  if (val === e.defaultOn) delete obj[key]; else obj[key] = val;
}

// ANAHTAR CEVIRME KURALI — TEK GOVDE (29 Agu 2026).
//
// 🔑 Serkan: *"1. kapaninca 2. otomatik kapansin; ancak 1. acilinca 2. ister
//    on ister off olsun."*
//   · Ebeveyn KAPANIR -> bagli anahtarlar da kapanir (okuyacaklari veri yok).
//   · Ebeveyn ACILIR  -> bagli anahtara DOKUNULMAZ; yonetici karar verir.
//     Ters yonu de otomatiklestirseydik, PERF'i geri acan yonetici pist
//     ozelliginin de dondugunu SANIRDI — halbuki bir sey degismemis olurdu.
//   · Ebeveyn kapaliyken bagli anahtar ACILAMAZ: acilsa "ON" gorunup hicbir
//     sey yapmazdi ve sistem calismayan bir seyi calisiyormus gibi gosterirdi
//     (Ilke 1).
//
// ⚠️ GOVDE BURADA DURUR, PANELDE DEGIL. Panelde kalsaydi test edilemezdi ve
// testin kopyaladigi kural ile panelin uyguladigi kural sessizce ayrisirdi.
// Degismediyse AYNI nesne doner — cagiran "hicbir sey olmadi"yi anlayabilsin.
export function toggleFeature(features, key) {
  const f = BY_KEY[key];
  if (!f) return features;
  if (f.dependsOn && !isEnabled(features, f.dependsOn)) return features;
  const next = { ...features };
  const val = !isEnabled(features, key);
  yaz(next, key, val);
  if (!val) for (const c of dependentsOf(key)) yaz(next, c, false);
  return next;
}

// Bir anahtar bu musteride etkin mi?
// features = customers.features (yalniz sapmalar). Bilinmeyen anahtar -> true (Kural 8).
export function isEnabled(features, key) {
  const entry = BY_KEY[key];
  if (!entry) return true;
  const v = features ? features[key] : undefined;
  if (v === undefined || v === null) return entry.defaultOn;
  return v !== false;
}

// Kapatilmak istenen anahtarlarin etkileri — SAVE oncesi ozet ekrani icin.
export function affectsOf(keys) {
  return keys
    .map(k => BY_KEY[k])
    .filter(Boolean)
    .map(f => ({ key: f.key, label: f.label, module: f.module, affects: f.affects, note: f.note }));
}

// DEGER AYARLARI — anahtar DEGIL, sirketin kendi sutununda duran deger (3 Kas 2026).
// 🔑 Serkan (2 Kas): *"super adminde de bu veri olacak, default; her sirket kendi verisini girebilecek"* ·
//    *"simdikinin aynisi olacak, sadece default deger degisecek, ustune yazilabilir"* -> aralik YOK, yalniz sayi.
// customers.features'a GIRMEZ (iPad onu [String: Bool] cozer; sayi girerse butun ayarlar bos okunur).
// Varsayilan DB'de (sutunun DEFAULT'u, 20261103a) — burada ikinci bir kopyasi yok.
export const DEGER_AYARLARI = [
  {
    column: 'default_fuel_density', section: 'ui', module: 'FUEL', label: 'DEFAULT DENSITY (KG/LT)',
    aciklama: 'Prefilled in the DENSITY cell of the iPad FUEL module; the pilot can overwrite it.',
  },
];

// Deger hucresindeki metin -> sayi; sayi degilse null. Hucre sayi tipindedir (harf girmez); bu ikinci kapi
// bos, eksi ve ustlu yazimi (1e3) da reddeder.
export function sayiOku(metin) {
  const s = String(metin ?? '').trim();
  return /^(\d+(\.\d+)?|\.\d+)$/.test(s) ? Number(s) : null;
}

// SIRA UYGULAMANIN AKISIDIR (Serkan 2 Kas: *"app'de sirasi neyse orada olmali"* · *"super adminde de bir akis
// olmali"*): UI kutulari iPad sol kolonundaki modul sirasiyla dizilir. Listede olmayan modul GIZLENMEZ, sona
// eklenir (Kural 8) — test her modulun listede oldugunu ayrica soyler.
export const UI_MODUL_SIRASI = [
  'FLT CREW', 'FUEL', 'RAAQ', 'T/O DATA', 'T/O + LDG DATA', 'NAVLOG', 'LDG DATA', 'DOC UPLOAD',
];

// Settings ekraninin agaci: bolum -> modul -> anahtarlar (items) + deger satirlari (degerler).
export function catalogTree(section) {
  const modules = [];
  const grup = (ad) => {
    let m = modules.find(x => x.module === ad);
    if (!m) { m = { module: ad, items: [], degerler: [] }; modules.push(m); }
    return m;
  };
  for (const r of FEATURE_CATALOG.filter(f => f.section === section)) grup(r.module).items.push(r);
  for (const d of DEGER_AYARLARI.filter(x => x.section === section)) grup(d.module).degerler.push(d);
  if (section !== 'ui') return modules;
  const yer = (ad) => { const i = UI_MODUL_SIRASI.indexOf(ad); return i < 0 ? UI_MODUL_SIRASI.length : i; };
  return modules.map((m, i) => ({ m, i })).sort((a, b) => yer(a.m.module) - yer(b.m.module) || a.i - b.i).map(x => x.m);
}

export const FEATURE_KEYS = FEATURE_CATALOG.map(f => f.key);
